module.exports = __webpack_public_path__ + "static/nxrt-rail4-7ebf880fb8cf3ae64d0ab8056e5bfcfd.png";